import { render, staticRenderFns } from "./IconFeed.vue?vue&type=template&id=5b674ce4&"
import script from "./IconFeed.vue?vue&type=script&lang=js&"
export * from "./IconFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b674ce4')) {
      api.createRecord('5b674ce4', component.options)
    } else {
      api.reload('5b674ce4', component.options)
    }
    module.hot.accept("./IconFeed.vue?vue&type=template&id=5b674ce4&", function () {
      api.rerender('5b674ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconFeed.vue"
export default component.exports